import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "shorteval-form-component" }
const _hoisted_2 = { class: "step-1" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_8 = { class: "infobox-container" }
const _hoisted_9 = { class: "infobox" }
const _hoisted_10 = { class: "infobox-content" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "row my-3"
}
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-5" }
const _hoisted_18 = { class: "col-lg-7" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "row"
}
const _hoisted_21 = { class: "col-lg-8" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-8" }
const _hoisted_24 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_25 = { class: "infobox-container mb-5" }
const _hoisted_26 = { class: "infobox" }
const _hoisted_27 = { class: "infobox-content" }
const _hoisted_28 = ["src"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "my-4" }
const _hoisted_33 = { class: "my-4" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "col-lg-4" }
const _hoisted_37 = { class: "infobox-container" }
const _hoisted_38 = { class: "infobox" }
const _hoisted_39 = { class: "infobox-content" }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "row mb-4" }
const _hoisted_43 = { class: "col-lg-8" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "form-control-wrapper my-3" }
const _hoisted_46 = { class: "check blue-checkbox" }
const _hoisted_47 = { for: 'fieldEmailContactCheckboxId' }
const _hoisted_48 = { class: "row mb-5" }
const _hoisted_49 = { class: "col-lg-8" }
const _hoisted_50 = {
  key: 0,
  class: "row"
}
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "buttons-content container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_component = _resolveComponent("radio-component")!
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_input_component = _resolveComponent("input-component")!
  const _component_select_component = _resolveComponent("select-component")!
  const _component_hsn_tsn_warning_component = _resolveComponent("hsn-tsn-warning-component")!
  const _component_date_component = _resolveComponent("date-component")!
  const _component_car_component = _resolveComponent("car-component")!
  const _component_motorcycle_component = _resolveComponent("motorcycle-component")!
  const _component_result_component = _resolveComponent("result-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("form", {
        action: "",
        id: "",
        method: "post",
        ref: "shortEvalForm",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_radio_component, {
                options: {
                    1 : {
                      label: 'Auto',
                      value: true,
                      image: _ctx.icons.car
                    },
                    2 : {
                      label: 'Motorrad',
                      value: false,
                      image: _ctx.icons.motorcycle
                    }
                  },
                name: 'isCar',
                gap: '',
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].isCar.value.toString(),
                "default-value": _ctx.defaultValues.isCar.toString(),
                id: 'vehicle-type',
                "div-class": 'shorteval-vehicle-type mb-3',
                "label-class": 'shorteval-vehicle-type-label',
                "error-message": 'Bitte wählen Sie einen Fahrzeugtyp (Auto oder Motorrad).',
                required: true,
                title: _ctx.labels.vehicleTypeQuestion
              }, null, 8, ["options", "value", "default-value", "error-message", "title"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_radio_component, {
                options: {
                    1 : {
                      label: 'Ja',
                      value: true
                    },
                    2 : {
                      label: 'Nein',
                      value: false
                    }
                  },
                name: 'useHsnTsn',
                gap: '',
                "modal-class": 'd-inline use-hsn-tsn-modal ms-2',
                "modal-title": _ctx.settings.hsnTitle,
                "modal-text": _ctx.settings.hsnBody,
                "modal-cancel-button": 'Schließen',
                "modal-cancel-button-class": 'btn btn-outline-secondary',
                "show-confirm-button": false,
                "show-cancel-button": true,
                "div-class": 'shorteval-vehicle-type mb-3',
                "label-class": 'shorteval-vehicle-type-label',
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].useHsnTsn.value.toString(),
                "default-value": _ctx.defaultValues.useHsnTsn.toString(),
                id: 'vehicle-registration-document',
                title: _ctx.labels.vehicleRegistrationDocumentQuestion
              }, null, 8, ["modal-title", "modal-text", "value", "default-value", "title"])
            ]),
            (_ctx.showHsnTsnInfoBox)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.icons.lightbulb)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.icons.lightbulb,
                              alt: 'Light bulb info box',
                              class: "me-2 img-fluid"
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        (_ctx.labels.hsnTsnInfoboxText)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              innerHTML: _ctx.labels.hsnTsnInfoboxText
                            }, null, 8, _hoisted_12))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.useHsnTsn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    (_ctx.labels.hsntsnText)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fw-bold mb-3 d-block",
                          innerHTML: _ctx.labels.hsntsnText
                        }, null, 8, _hoisted_15))
                      : _createCommentVNode("", true),
                    _createVNode(_component_modal_component, {
                      "btn-title": 'Wo finde ich die HSN und TSN?',
                      title: _ctx.settings.hsnTitle,
                      body: _ctx.settings.hsnBody,
                      "cancel-button-text": 'Schließen',
                      "cancel-button-class": 'btn btn-outline-secondary',
                      "show-cancel-button": true,
                      "show-confirm-button": false,
                      link: 'link',
                      "class-div": '',
                      "btn-class": 'shorteval-btn',
                      "icon-path-before": _ctx.icons.info
                    }, null, 8, ["title", "body", "icon-path-before"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_input_component, {
                        value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldHSN.value,
                        size: 'large',
                        type: 'text',
                        id: 'fieldHSN',
                        name: 'fieldHSN',
                        pattern: '[0-9]{4}',
                        maxlength: 4,
                        "class-input": 'el-input-custom my-2',
                        placeholder: 'HSN',
                        "filter-property": ['hsntsn', 'hsn']
                      }, null, 8, ["value"]),
                      _createVNode(_component_input_component, {
                        value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldTSN.value,
                        size: 'large',
                        type: 'text',
                        id: 'fieldTSN',
                        name: 'fieldTSN',
                        pattern: '[0-9A-Za-z]{3}',
                        maxlength: 3,
                        "class-input": 'el-input-custom my-2',
                        placeholder: 'TSN',
                        "filter-property": ['hsntsn', 'tsn']
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.images.hsnDefaultImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.images.hsnDefaultImage,
                            alt: "vehicle certificate",
                            class: "img-responsive"
                          }, null, 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.useHsnTsn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_select_component, {
                    items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
                    "default-value": _ctx.defaultValues.manufacturer.toString(),
                    title: _ctx.labels.vehicleBrandQuestion,
                    name: 'vehicle',
                    id: 'vehicle',
                    class: _normalizeClass('shorteval-vehicle-brand'),
                    "class-input": 'form-control fieldVehicle p-3',
                    "radio-title": 'Häufigste Marken',
                    placeholder: 'Alle Marken',
                    "default-title": 'Marken',
                    required: true,
                    filter: true,
                    "radio-div-class": 'mb-3',
                    "filter-property": ['selection', 'manufacturer'],
                    "frequent-item-keys": ['905', '570', '650', '285', '130', '60'],
                    "frequent-group-label": 'Häufigste Marken',
                    "all-group-label": 'Alle Marken',
                    "error-message": 'Bitte wählen Sie eine Option aus.',
                    disabled: false
                  }, null, 8, ["items", "default-value", "title", "error-message"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_hsn_tsn_warning_component, {
            step: 1,
            name: 'hsn-tsn-warning-step-1'
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['step-2', !_ctx.isStepAvailable(_ctx.store, 2) ? 'hidden' : ''])
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_date_component, {
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].firstRegistration.value,
                size: 'large',
                id: 'firstRegistration',
                name: 'firstRegistration',
                placeholder: 'Erstzulassung',
                "class-input": 'el-date-custom',
                "class-div": 'col-lg-4 col-md-12',
                "error-message": 'Bitte ergänzen Sie den Monat/ das Jahr der Erstzulassung.',
                format: 'MM/YYYY',
                "value-format": 'MM/YYYY',
                "filter-property": ['selection', 'firstRegistration'],
                "default-value": _ctx.defaultValues.firstRegistration,
                title: _ctx.labels.vehicleFirstRegisteredQuestion
              }, null, 8, ["value", "error-message", "default-value", "title"])
            ]),
            (_ctx.showFirstRegistrationDateInfoBox)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.icons.lightbulb)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.icons.lightbulb,
                              alt: 'Light bulb info box',
                              class: "me-2 img-fluid"
                            }, null, 8, _hoisted_28))
                          : _createCommentVNode("", true),
                        (_ctx.labels.hsnTsnInfoboxText)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              innerHTML: _ctx.labels.firstRegistrationInfoboxText
                            }, null, 8, _hoisted_29))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_input_component, {
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].mileage.value,
                size: 'large',
                title: _ctx.labels.currentMileageQuestion,
                type: 'text',
                id: 'mileage',
                name: 'mileage',
                required: true,
                min: 2,
                max: 250000,
                step: 1000,
                pattern: '[0-9]',
                "class-input": 'el-input-custom my-2',
                "class-div": 'col-lg-4 col-md-12',
                placeholder: 'Kilometerstand',
                "filter-property": ['valuate','mileage'],
                "default-value": _ctx.defaultValues.mileage,
                append: 'km',
                "error-message": 'Bitte geben Sie hier Ihren aktuellen Kilometerstand an (maximal 250.000km), verwenden Sie dabei nur Zahlen.'
              }, null, 8, ["value", "title", "default-value", "error-message"])
            ])
          ]),
          _createVNode(_component_hsn_tsn_warning_component, {
            step: 2,
            name: 'hsn-tsn-warning-step-2'
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['step-3', !_ctx.isStepAvailable(_ctx.store, 3) ? 'hidden' : ''])
        }, [
          _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.labels.chapterVehicleDetails), 1),
          (_ctx.isCar === true)
            ? (_openBlock(), _createBlock(_component_car_component, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isCar === false)
            ? (_openBlock(), _createBlock(_component_motorcycle_component, { key: 1 }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['step-5', !_ctx.isStepAvailable(_ctx.store, 5) ? 'hidden' : ''])
        }, [
          _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.labels.chapterLocation), 1),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_input_component, {
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldLocation.value,
                size: 'large',
                type: 'text',
                id: 'fieldLocation',
                name: 'fieldLocation',
                pattern: '[0-9]{5}',
                maxlength: 5,
                "class-input": 'el-input-custom my-2',
                "class-div": 'col-lg-4 col-md-12',
                placeholder: 'Postleitzahl',
                required: true,
                "filter-property": ['valuate', 'location'],
                "error-message": 'Bitte tragen Sie hier Ihre 5-stellige Postleitzahl ein.'
              }, null, 8, ["value", "error-message"]),
              _createVNode(_component_input_component, {
                value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldEmail.value,
                size: 'large',
                type: 'email',
                id: 'fieldEmail',
                name: 'fieldEmail',
                pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                "class-input": 'el-input-custom my-2 w-100',
                placeholder: 'E-Mail (Angabe freiwillig)',
                required: _ctx.emailRequiredValue,
                "filter-property": ['valuate', 'email'],
                "error-message": _ctx.labels.doiEmailEmpty
              }, null, 8, ["value", "pattern", "placeholder", "required", "error-message"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.icons.lightbulb)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.icons.lightbulb,
                          alt: 'Light bulb info box',
                          class: "me-2 img-fluid"
                        }, null, 8, _hoisted_40))
                      : _createCommentVNode("", true),
                    (_ctx.labels.emailInfoboxText)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          innerHTML: _ctx.labels.emailInfoboxText
                        }, null, 8, _hoisted_41))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              (_ctx.labels.sendEvaluationEmail)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    innerHTML: _ctx.labels.sendEvaluationEmail
                  }, null, 8, _hoisted_44))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: 'fieldEmailContactCheckboxId',
                    value: "1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                  }),
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.labels.doiLabel1), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              (_ctx.labels.doiLabel1 || _ctx.labels.doiLabel2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_ctx.labels.doiLabel2)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 0,
                          class: "mb-2",
                          innerHTML: _ctx.labels.doiLabel2
                        }, null, 8, _hoisted_51))
                      : _createCommentVNode("", true),
                    (_ctx.labels.disclaimerEvaluationResult)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 1,
                          innerHTML: _ctx.labels.disclaimerEvaluationResult
                        }, null, 8, _hoisted_52))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["buttons-form-container sticky-progress mt-5", {
                'is-sticky d-flex': _ctx.isStickyButtonsContainer,
                'd-block': !_ctx.isStickyButtonsContainer,
              }])
        }, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToResultPage && _ctx.goToResultPage(...args))),
              class: _normalizeClass([
                  'btn', 'me-md-3',
                  _ctx.settings.secondButtonColor || 'btn-primary',
                  !_ctx.isFormValid ? 'btn-disabled' : ''
                ])
            }, _toDisplayString(_ctx.labels.buttonFindOutRatingVehicle), 3)
          ])
        ], 2)
      ], 544)
    ], 512), [
      [_vShow, !_ctx.showResultPage]
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_component_result_component, { "is-showed": _ctx.showResultPage }, null, 8, ["is-showed"]), [
        [_vShow, _ctx.showResultPage]
      ])
    ])
  ]))
}